import { render, staticRenderFns } from "./getDeviceInfo.vue?vue&type=template&id=5b82dca0&scoped=true&"
import script from "./getDeviceInfo.vue?vue&type=script&lang=js&"
export * from "./getDeviceInfo.vue?vue&type=script&lang=js&"
import style0 from "./getDeviceInfo.vue?vue&type=style&index=0&id=5b82dca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b82dca0",
  null
  
)

export default component.exports